export enum PrintMode {
    AutoSelect,
    ForcePDFPlugin,
    ForcePDFFile
}
